export default __webpack_public_path__ + "static/media/granville01.f266d51c.jpg";